module.exports = __webpack_public_path__ + "static/media/retroDiner.648822a4.jpg";